import PropTypes from 'prop-types'
import { NavLink } from 'react-router-dom'
import { Lock } from '@phosphor-icons/react'

const ToolbarMenu = ({ routes = [] }) => {
  return (
    <nav className="visitors-toolbar-menu">
      <ul>
        {routes.map(
          ({ name, path, hidden, lock }) =>
            !hidden && (
              <li key={name}>
                <NavLink to={path} className={({ isActive }) => (isActive ? 'is-active' : '')}>
                  <span>
                    {lock && <Lock size={18} className="visitor-nav-item-lock-icon" />} {name}
                  </span>
                </NavLink>
              </li>
            ),
        )}
      </ul>
    </nav>
  )
}

ToolbarMenu.propTypes = {
  routes: PropTypes.array,
}

export default ToolbarMenu
